import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";

import DashboardPage from "../pages/DashboardPage";

const meApiUrl = `${process.env.REACT_APP_BACKEND_URL}/api/auth/me`;

export default function ProtectedDashboard() {
  const location = useLocation();
  const navigate = useNavigate();
  const [user, setUser] = useState(location.state?.user || null);
  const [isAuthenticated, setIsAuthenticated] = useState(location.state?.user ? true : null);

  useEffect(() => {
    const checkAuth = async () => {
      if (location.state?.user) {
        return;
      }
      try {
        const response = await axios.get(meApiUrl, { withCredentials: true });
        setUser(response.data);
        setIsAuthenticated(true);
      } catch (error) {
        setIsAuthenticated(false);
        navigate("/login", { replace: true });
      }
    };
    checkAuth();
  }, [location.state, navigate]);

  const logout = async () => {
    await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}/api/auth/logout`,
      {},
      { withCredentials: true },
    );
    navigate("/login", { replace: true });
  };

  if (isAuthenticated !== true || !user) {
    return <main className="auth-check" data-testid="auth-check-state" />;
  }

  return <DashboardPage user={user} onLogout={logout} />;
}